import React, { useState, useEffect } from 'react';
import AUX from '../AU-X/AU-X';

import Spinner from '../../Components/UI/Spinner/Spinner';
import Modal from '../../Components/UI/Modal/Modal';
import ShowError from '../../Components/UI/ShowError/ShowError';
import { useSelector } from 'react-redux';

const SpinnerHandler = (props) => {
  const [show, setShow] = useState(false);

  const { children } = props;
  const { showError, modal, isLoading } = useSelector((state) => ({
    showError: state.showError,
    isLoading: state.isLoading,
    modal: state.modal,
  }));

  useEffect(() => {
    const forModal = modal && modal.text;
    setShow(isLoading || forModal);
  }, [modal, isLoading]);

  return (
    <AUX>
      {isLoading && <Spinner />}
      {modal && (
        <Modal
          {...modal}
          // position={modal.position}
          // responsive={modal.responsive}
          // text={modal.text}
          // onClick={modal.onClick}
        />
      )}
      {showError && <ShowError type={showError.type}>{showError.message}</ShowError>}

      <div style={{ opacity: show ? '0.7' : '1', transition: 'all 0.3s ease-out' }}>{children}</div>
    </AUX>
  );
};

export default SpinnerHandler;
